import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import * as authApi from "../api/auth";
import CampoPassword from "../components/CampoPassword";

function validarPassword(password) {
  if (password.length < 8) return "La contraseña debe tener al menos 8 caracteres.";
  if (!/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) return "La contraseña debe incluir letras y números.";
  return null;
}

export default function RestablecerPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmarPassword, setConfirmarPassword] = useState("");
  const [error, setError] = useState("");
  const [exito, setExito] = useState(false);
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) { setError("Enlace inválido: falta el token."); return; }

    const errorPassword = validarPassword(password);
    if (errorPassword) { setError(errorPassword); return; }
    if (password !== confirmarPassword) { setError("Las contraseñas no coinciden."); return; }

    setCargando(true);
    try {
      await authApi.resetPassword(token, password, confirmarPassword);
      setExito(true);
    } catch (err) {
      setError(err.response?.data?.mensaje || "No se pudo restablecer la contraseña.");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center px-3"
         style={{ background: "linear-gradient(160deg, #0C8599 0%, #075463 100%)" }}>
      <div className="fs-card shadow-lg" style={{ maxWidth: 420, width: "100%" }}>
        <div className="text-center mb-4">
          <div className="fs-display" style={{ fontSize: "1.6rem", color: "var(--fs-primary)" }}>
            FinanzasSys
          </div>
          <div className="text-muted small">Restablecer contraseña</div>
        </div>

        {!token && (
          <Alert variant="danger" className="py-2">Enlace inválido: falta el token.</Alert>
        )}

        {exito ? (
          <>
            <div className="text-center mb-3">
              <i className="bi bi-check-circle-fill text-fs-ingreso" style={{ fontSize: "2.5rem" }}></i>
              <h5 className="mt-3">¡Contraseña actualizada!</h5>
              <p className="text-muted">Ya puedes iniciar sesión con tu nueva contraseña.</p>
            </div>
            <Link to="/login" className="btn btn-primary w-100">Ir a iniciar sesión</Link>
          </>
        ) : (
          <Form onSubmit={handleSubmit}>
            {error && <Alert variant="danger" className="py-2">{error}</Alert>}
            <CampoPassword label="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
            <CampoPassword label="Confirmar contraseña" value={confirmarPassword} onChange={(e) => setConfirmarPassword(e.target.value)} autoComplete="new-password" />
            <Form.Text className="text-muted d-block mb-3" style={{ marginTop: "-0.75rem" }}>
              Mínimo 8 caracteres, incluyendo letras y números.
            </Form.Text>
            <Button type="submit" variant="primary" className="w-100" disabled={cargando || !token}>
              {cargando ? <Spinner size="sm" animation="border" /> : "Restablecer contraseña"}
            </Button>
            <div className="text-center mt-3">
              <Link to="/login" className="small">Volver a iniciar sesión</Link>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
}
